/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { telemetryGetUnproxiedMcpServerUserUsage } from "../funcs/telemetryGetUnproxiedMcpServerUserUsage.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetUnproxiedMcpServerUserUsageResult } from "../models/components/getunproxiedmcpserveruserusageresult.js";
import {
  GetUnproxiedMcpServerUserUsageRequest,
  GetUnproxiedMcpServerUserUsageSecurity,
} from "../models/operations/getunproxiedmcpserveruserusage.js";
import { unwrapAsync } from "../types/fp.js";
export type GetUnproxiedMcpServerUserUsageQueryData =
  GetUnproxiedMcpServerUserUsageResult;

export function prefetchGetUnproxiedMcpServerUserUsage(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetUnproxiedMcpServerUserUsageRequest,
  security?: GetUnproxiedMcpServerUserUsageSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetUnproxiedMcpServerUserUsageQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetUnproxiedMcpServerUserUsageQuery(
  client$: GramCore,
  request: GetUnproxiedMcpServerUserUsageRequest,
  security?: GetUnproxiedMcpServerUserUsageSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetUnproxiedMcpServerUserUsageQueryData>;
} {
  return {
    queryKey: queryKeyGetUnproxiedMcpServerUserUsage({
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function getUnproxiedMcpServerUserUsageQueryFn(
      ctx,
    ): Promise<GetUnproxiedMcpServerUserUsageQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(telemetryGetUnproxiedMcpServerUserUsage(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetUnproxiedMcpServerUserUsage(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "telemetry",
    "getUnproxiedMcpServerUserUsage",
    parameters,
  ];
}
